import { type Workspace } from '@/features/iam/workspaces/Workspace'
import { type CallCenterWorkspaceMemberMatch } from './call-center-search-result'
import type { Membership } from '@/features/iam/workspaces/Membership'

export function isCallCenterEnabledInWorkspace(workspace: Workspace) {
  return workspace.config.callCenter.enabled
}

export function filterCallCenterMemberships(memberships: Membership[]) {
  return memberships.filter((membership) =>
    isCallCenterEnabledInWorkspace(membership.workspace),
  )
}

export function filterCallCenterWorkspaceMembersMatches(
  workspaceMembersMatches: CallCenterWorkspaceMemberMatch[],
) {
  return workspaceMembersMatches.filter((match) =>
    isCallCenterEnabledInWorkspace(match.workspace),
  )
}
